'use strict';

angular.module('nfseApp')
    .component('dadosPessoaisEdit', {
        restrict: 'E',
        templateUrl: 'app/component/dadospessoais/dados-pessoais-edit.html',
        bindings: {
            dadosPessoais: '=',
            formReference: '<'
        },
        controllerAs: 'vm',
        controller: function ($scope, Pessoa, CEP, $modal, $timeout) {
            var vm = this;

            $timeout(function () {
                if (!vm.dadosPessoais) {
                    vm.dadosPessoais = {cpfCnpj: ""}
                }
            }, 1000);

            $scope.preLoadResponsavel = function () {
                if (vm.dadosPessoais.cpfCnpj) {
                    Pessoa.getPorCpfCnpj({cpfCnpj: vm.dadosPessoais.cpfCnpj}, function (data) {
                        if (data.id) {
                            vm.dadosPessoais = data;
                        }
                    })
                }
            };


            $scope.isFisica = function () {
                return vm.dadosPessoais &&
                    vm.dadosPessoais.cpfCnpj &&
                    vm.dadosPessoais.cpfCnpj.replace(/[^\w\s]/gi, '').length == 11;
            };

            $scope.loadEnderecoByCEP = function (cep) {
                if (cep) {
                    CEP.getByCep({cep: cep}, function (endereco) {
                        if (endereco.municipio) {
                            vm.dadosPessoais.cep = endereco.cep;
                            vm.dadosPessoais.municipio = endereco.municipio;
                            vm.dadosPessoais.logradouro = endereco.logradouro;
                            vm.dadosPessoais.bairro = endereco.bairro;
                        }
                    });
                }
            };

            $scope.searchMunicipio = function (caraQueTemMunicipio) {
                var modalInstance = $modal.open({
                    templateUrl: 'app/entities/municipio/municipio-search.html',
                    controller: 'MunicipioSearchController',
                    size: 'lg'
                });
                modalInstance.result.then(function (municipio) {
                    caraQueTemMunicipio.municipio = municipio;
                    caraQueTemMunicipio.pais = {};
                }, function () {
                    //$log.info('Modal dismissed at: ' + new Date());
                });
            };
        }
    });
